<template>
  <div class="content-item-container">
   <div class="content-text">
     <div v-html="text"></div>
   </div>
  </div>
</template>

<style lang="scss">
  .content-item-container {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20vh 0;
  }
</style>

<script>
  export default {
    name: 'TextLongItem',
    props: {
      text: {
        type: String,
        default: ``
      }
    }
  }
</script>